<ng-container *ngIf="isLoaded && rowData.length; else loader">
  <table class="table">
    <thead class="table__thead">
      <tr class="table__tr">
        <th class="table__th">Name</th>
        <th class="table__th" *ngIf="currentSegment !== 'investor'">
          Client use
        </th>
        <th class="table__th">Literature Code</th>
        <th class="table__th">Publication</th>
        <th class="table__th">Next Update</th>
      </tr>
    </thead>
    <tbody>
      <tr
        class="table__tr table__tr--no-bg table__tr--border-bottom"
        *ngFor="let data of rowData"
      >
        <td class="table__td name">{{ data?.name }}</td>
        <td class="table__td" *ngIf="currentSegment !== 'investor'">
          {{ data?.clientUse }}
        </td>
        <td class="table__td docId">{{ data?.litCode }}</td>
        <td class="table__td">{{ data?.publicationDate }}</td>
        <td class="table__td">{{ data?.nextUpdateDate }}</td>
      </tr>
    </tbody>
  </table>
</ng-container>

<ng-template #loader>
  <ngx-spinner
    name="ListingDataLoadingSpinner"
    bdColor="#fff"
    size="medium"
    color="#e8e8e8"
    type="line-scale"
    [fullScreen]="true"
    ><p style="color: white">Loading...</p></ngx-spinner
  >
</ng-template>
